import { render } from "./pointsRules.vue?vue&type=template&id=0a8b7561"
import script from "./pointsRules.vue?vue&type=script&lang=js"
export * from "./pointsRules.vue?vue&type=script&lang=js"

import "./pointsRules.vue?vue&type=style&index=0&id=0a8b7561&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__